import colors from './colors';
export { colors };

// Shared date-time display format. Single source of truth — Vidende's
// constants/config re-exports this so both apps and @vidende/components agree.
export const defaultDateTimeFormat = 'D/MMM/YY h:mm A';
